import(/* webpackMode: "eager", webpackExports: ["LoginFormWithRedirect"] */ "/vercel/path0/src/app/[locale]/(auth)/login/LoginFormWithRedirect.tsx");
